/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryDetail>): ComplianceAssessmentHistoryDetail {
        let obj = Object.assign(new ComplianceAssessmentHistoryDetail(), model);
        ComplianceAssessmentHistoryDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryDetail>): ComplianceAssessmentHistoryDetail {
        if (!model) return null;
        return ComplianceAssessmentHistoryDetail.newInstance(<ComplianceAssessmentHistoryDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryDetail) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Assessment History Id
     */
    compliance_assessment_history_id: string;

    /**
     * Unique URI of compliance standard
     */
    compliance_standard_uri: string;

    /**
     * Unique Assessment job number of assessment triggered
     */
    assessment_job_number: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * When was the assessment trigger created
     */
    created_at: Date;

    /**
     * Name of the user who triggered assessment
     */
    created_by: string;

    /**
     * When was the assessment trigger updated
     */
    updated_at: Date;

    /**
     * Name of the user who triggered assessment
     */
    updated_by: string;

    /**
     * ID of service account
     */
    service_account_id: string;

    /**
     * Status of assessment trigger
     */
    assessment_status: models.AssessmentStatus;

    /**
     * Type of execution.
     */
    execution_type: models.AssessmentExecutionType;

}
